import React, { Fragment } from 'react';
import styled from "styled-components";
import mondrian from "../../../../core/config/theme";

const ModalContent = styled.div`
      font-size: ${mondrian.fontSizeXs};
      .mdn-Heading {
        margin-bottom: 16px;
      }
    .mdn-Modal--sm .mdn-Modal-content {
        height: auto !important;
    }
`;

const ModalBody = ({ message, instructions }) => (
  <ModalContent >
    <div className="mdn-Modal-body">
      {message && <Fragment>
        <div
          className="mdn-Text mdn-Text--body"
          dangerouslySetInnerHTML={{ __html: message }}
        ></div>
      </Fragment>}
      {instructions && <Fragment>{instructions}</Fragment>}
    </div>
  </ModalContent>
);

export default ModalBody;
